import React from 'react';

import BlankCard from '~components/atoms/BlankCard';
import CustomSkeleton from '~components/atoms/Skeleton';

import * as Styles from './InventoryReportCardsSummary.module.scss';

import { useAppSelector } from '~redux/hooks';

import UtilFunctions from '~utils/functions';
import { TGetInventoryReportCardSummaryAPIResponse } from '~types/feat/report';

type InventoryReportCardsSummaryProps = {
    summaryData: TGetInventoryReportCardSummaryAPIResponse;
};

const InventoryReportCardsSummary = ({ summaryData }: InventoryReportCardsSummaryProps) => {
    const loading = useAppSelector(state => state.report.loadings.getInventoryReportCardSummary);

    const renderValue = (value: string | number) => (
        loading
            ? <CustomSkeleton height={30} />
            : Number(value).toLocaleString('en-MY', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3,
            })
    );

    return (
        <div className={Styles.container}>
            <div>
                <BlankCard>
                    <div className={Styles['card-content']}>
                        <p>GOLD TOTAL (G)</p>
                        <h3>{renderValue(`${summaryData.gold.total}`)}</h3>
                    </div>
                </BlankCard>

                <BlankCard>
                    <div className={Styles['card-content']}>
                        <p>ALLOCATED GOLD (G)</p>
                        <h3>{renderValue(summaryData.gold.allocated)}</h3>
                    </div>
                </BlankCard>

                <BlankCard>
                    <div className={Styles['card-content']}>
                        <p>AVAILABLE GOLD (G)</p>
                        <h3>{renderValue(`${summaryData.gold.available}`)}</h3>
                    </div>
                </BlankCard>
            </div>

            <div>
                <BlankCard>
                    <div className={Styles['card-content']}>
                        <p>SILVER TOTAL (G)</p>
                        <h3>{renderValue(`${summaryData.silver.total}`)}</h3>
                    </div>
                </BlankCard>

                <BlankCard>
                    <div className={Styles['card-content']}>
                        <p>ALLOCATED SILVER (G)</p>
                        <h3>{renderValue(`${summaryData.silver.allocated}`)}</h3>
                    </div>
                </BlankCard>

                <BlankCard>
                    <div className={Styles['card-content']}>
                        <p>AVAILABLE SILVER (G)</p>
                        <h3>{renderValue(`${summaryData.silver.available}`)}</h3>
                    </div>
                </BlankCard>
            </div>
        </div>
    );
};

export default InventoryReportCardsSummary;
